import React from 'react';
import { connect } from 'react-redux';
import {
    change,
    destroy,
    initialize,
    isPristine,
    getFormSyncErrors,
    formValueSelector,
    hasSubmitFailed
} from 'redux-form';
import {
    Table,
    TableBody,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn,
    Popover,
    IconButton,
    FlatButton,
    Menu,
    MenuItem,
    Divider,
    Dialog
} from 'material-ui';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import ModeEditIcon from 'material-ui/svg-icons/editor/mode-edit';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import PauseIcon from 'material-ui/svg-icons/av/pause';
import AddIcon from 'material-ui/svg-icons/content/add';
import _ from 'lodash';
import humanize from 'humanize-string';
import FormWizzard from './FormWizzard';
import { getEntities } from 'dash-front/selectors';
import { CAMPAIGN_FORM_KEYS, CAMPAIGN_FORM_ID, WIZZARD_FORM_ID, STORE_KEYS } from 'dash-front/constants';
import ErrorComponent from '../../components/Form/Error';
import { ReadableCondition } from '../../components/ReadableCondition';

const dialogContentStyle = {
    width: '90%',
    maxWidth: 'none'
};

const errSelect = state => {
    const value = _.get(getFormSyncErrors(CAMPAIGN_FORM_ID)(state), 'rules');
    return { value };
};
const ErrorEnhanced = connect(errSelect)(ErrorComponent);

const WizzardErrorEnhanced = connect(state => ({
    value: hasSubmitFailed(WIZZARD_FORM_ID)(state) ? getFormSyncErrors(WIZZARD_FORM_ID)(state) : null
}))(ErrorComponent);

const TRGR_FORM_KEY = CAMPAIGN_FORM_KEYS.RULES.KEY;
const PRES_NAME = CAMPAIGN_FORM_KEYS.WIDGET.SECTION + '.' + CAMPAIGN_FORM_KEYS.WIDGET.NAME;

/**
 * Redux form component
 */
class RulesArray extends React.Component {
    constructor(props, ctx) {
        super(props, ctx);
        this.state = {
            popoverSelected: null,
            open: false,
            selectedIndex: null,
            showAlert: false
        };
    }

    onPopoverOpen = fieldName => event => {
        event.preventDefault();
        this.setState({
            popoverSelected: fieldName,
            anchorEl: event.currentTarget
        });
    };

    onPopoverClose = () => this.setState({ popoverSelected: null });

    onRuleEdit = (name, index) => {
        const { values } = this.props;
        this.onPopoverClose();
        this.openDialog(index);
        this.props.dispatch(initialize(WIZZARD_FORM_ID, values[index]));
    };

    onRuleRemove = index => {
        const { fields } = this.props;
        fields.remove(index);
        this.onPopoverClose();
    };

    onRuleAdd = () => {
        const { fields } = this.props;
        const selectedIndex = fields.length;
        this.openDialog(selectedIndex);
    };

    openDialog = selectedIndex => {
        this.setState({ open: true, selectedIndex });
    };

    onRuleSave = value => {
        const { selectedIndex } = this.state;
        const {
            fields: { name }
        } = this.props;
        this.props.dispatch(change(CAMPAIGN_FORM_ID, name + '.' + selectedIndex, value));
        this.closeDialog();
    };

    onCloseDialog = () => {
        const { wizzardIsPristine } = this.props;
        if (wizzardIsPristine) {
            this.closeDialog();
        } else {
            this.setState({ showAlert: true });
        }
    };

    closeDialog = () => {
        const { dispatch } = this.props;
        this.setState({ open: false, selectedIndex: null, showAlert: false });
        dispatch(destroy(WIZZARD_FORM_ID));
    };

    renderActionsCell = (field, index) => {
        return (
            <div>
                <IconButton onTouchTap={this.onPopoverOpen(field)}>
                    <MoreVertIcon />
                </IconButton>
                <Popover
                    open={this.state.popoverSelected === field}
                    onRequestClose={this.onPopoverClose}
                    anchorEl={this.state.anchorEl}
                    anchorOrigin={{
                        horizontal: 'left',
                        vertical: 'bottom'
                    }}
                    targetOrigin={{ horizontal: 'left', vertical: 'top' }}
                >
                    <Menu>
                        <MenuItem
                            primaryText={'Edit'}
                            leftIcon={<ModeEditIcon />}
                            onTouchTap={() => this.onRuleEdit(field, index)}
                        />
                        <MenuItem
                            onTouchTap={this.onRuleRemove.bind(this, index)}
                            leftIcon={<DeleteIcon />}
                            primaryText={'Delete'}
                        />
                        {/* <MenuItem
                            leftIcon={<PauseIcon />}
                            primaryText={'Pause?'}
                        /> */}
                    </Menu>
                </Popover>
            </div>
        );
    };

    renderTable = () => {
        const { fields, values } = this.props;
        if (!fields || !values) {
            return null;
        }
        return (
            <Table selectable={false}>
                <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                    <TableRow>
                        <TableHeaderColumn>Widget</TableHeaderColumn>
                        {/* <TableHeaderColumn>Trigger type</TableHeaderColumn> */}
                        <TableHeaderColumn style={{ width: 500 }}>Conditions</TableHeaderColumn>
                        <TableHeaderColumn style={{ width: 72 }} />
                    </TableRow>
                </TableHeader>
                <TableBody displayRowCheckbox={false}>
                    {fields.map((field, index) => {
                        const rule = values[index];
                        const triggerType = _.get(rule, TRGR_FORM_KEY);
                        return (
                            <TableRow key={index}>
                                <TableRowColumn style={{ whiteSpace: 'normal' }}>
                                    <span
                                        style={{
                                            marginLeft: -8,
                                            display: 'inline-block',
                                            borderLeft: '3px solid #e0e0e0',
                                            paddingLeft: 5
                                        }}
                                    >
                                        {_.get(rule, PRES_NAME)
                                            .split(/(?=[A-Z])/)
                                            .join(' ')}
                                    </span>
                                </TableRowColumn>
                                {/* <TableRowColumn>{humanize(triggerType || '')}</TableRowColumn> */}
                                <TableRowColumn style={{ width: 500 }}>
                                    {_.get(rule, 'conditions', []).map((condition, cindex, arr) => (
                                        <div
                                            key={cindex}
                                            style={{
                                                marginTop: 4,
                                                marginBottom: 4
                                            }}
                                        >
                                            <ReadableCondition condition={condition} triggerType={triggerType} />
                                            {cindex + 1 < arr.length && <Divider />}
                                        </div>
                                    ))}
                                </TableRowColumn>
                                <TableRowColumn style={{ width: 72 }}>
                                    {this.renderActionsCell(field, index)}
                                </TableRowColumn>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        );
    };

    renderAlertDialog = () => {
        return (
            <Dialog
                open={this.state.showAlert}
                title={'Alert'}
                actions={
                    <div>
                        <FlatButton onTouchTap={() => this.setState({ showAlert: false })} label={'Cancel'} />
                        <FlatButton secondary onTouchTap={this.closeDialog} label={'Ok'} />
                    </div>
                }
            >
                All the data will not be saved.
            </Dialog>
        );
    };

    render() {
        return (
            <div>
                <div>
                    <ErrorEnhanced />
                </div>
                {!this.props.fields.length && (
                    <div
                        style={{
                            fontSize: '0.9em',
                            color: 'rgba(0, 0, 0, 0.4)',
                            margin: '12px 16px'
                        }}
                    >
                        <i>No rules</i>
                    </div>
                )}
                {this.renderTable()}
                <FlatButton primary label={'Add rule'} onTouchTap={this.onRuleAdd} icon={<AddIcon />} />
                <Dialog
                    onRequestClose={this.onCloseDialog}
                    open={this.state.open}
                    contentStyle={dialogContentStyle}
                    className={'no-padding-dialog'}
                    autoScrollBodyContent
                    repositionOnUpdate
                    autoDetectWindowHeight
                >
                    <WizzardErrorEnhanced />
                    <div style={{ display: 'flex' }}>
                        <div style={{ width: '400px' }}>
                            <p>Widget preview (with fake data)</p>
                            <WidgetPreviewEnhanced />
                        </div>
                        <div style={{ flexGrow: 1 }}>
                            <FormWizzard onSave={this.onRuleSave} />
                        </div>
                    </div>
                </Dialog>
                {this.renderAlertDialog()}
            </div>
        );
    }
}

const mapPropsToWidgetParams = props =>
    Object.keys(props).reduce((acc, cur) => {
        const key = 'data-' + _.kebabCase(cur);
        acc[key] = props[cur];
        return acc;
    }, {});

const getExampleParams = (widgetName, widgets) => {
    if (!widgetName || !Array.isArray(widgets)) {
        return {};
    }
    const widget = widgets.find(w => w.id === widgetName);
    if (!widget) {
        return {};
    }
    const {
        spec: { demo }
    } = widget;
    const { props } = demo[0];
    const additional = mapPropsToWidgetParams(props);
    return {
        'data-name': widgetName,
        ...additional
    };
};

const WidgetPreview = ({ widgetName, user, widgets, template, additional }) => {
    if (!widgetName) {
        return <p>No widget selected</p>;
    }
    const widgetParameters = getExampleParams(widgetName, widgets);
    const userParams = (additional || []).reduce((acc, cur) => {
        if (!cur.byTrigger && cur.customValue) {
            acc[cur.key] = cur.customValue;
        }
        return acc;
    }, {});
    if (template) {
        userParams.template = template;
    }
    const resultParams = {
        ...widgetParameters,
        ...mapPropsToWidgetParams(userParams)
    };
    return (
        <div style={{ width: '400px' }}>
            <rlz-widget
                key={JSON.stringify({ resultParams })}
                data-client={user.client}
                data-user={user.username}
                data-token={user.accessToken}
                data-load={'sm'}
                {...resultParams}
                data-zoom={0.5}
            />
        </div>
    );
};

const wizzardSelector = formValueSelector(WIZZARD_FORM_ID);
const mapStateToPreviewProps = state => {
    return {
        user: state.user,
        widgetName: wizzardSelector(state, 'presentation.name'),
        template: wizzardSelector(state, 'presentation.params.template'),
        additional: wizzardSelector(state, 'presentation.additional'),
        widgets: _.get(getEntities(state)[STORE_KEYS.WIDGET_SPECS], 'widgets')
    };
};

const WidgetPreviewEnhanced = connect(mapStateToPreviewProps)(WidgetPreview);

const mapStateToProps = state => {
    return {
        values: formValueSelector(CAMPAIGN_FORM_ID)(state, CAMPAIGN_FORM_KEYS.RULES.ARRAY),
        wizzardIsPristine: isPristine(WIZZARD_FORM_ID)(state)
    };
};

export default connect(mapStateToProps)(RulesArray);



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/containers/Campaign/RulesArray.js
 **/